<agr-page-toolbar
  [pageTitle]="'reference-value-sheet.create-from-standard.title' | translate"
  [hasPrimaryAction]="false"
  data-test="reference-value-sheet-from-standard__overview"
>
  <div class="wrapper--spacing-horizontal">
    <div class="card">
      <agr-summary-card
        [title]="'reference-value-sheet.create-from-standard.scratch-title' | translate"
        [canExpand]="false"
        [actions]="[]"
      >
        <mat-list>
          <mat-list-item class="list-item">
            <p matListItemTitle>
              {{ 'reference-value-sheet.create-from-standard.scratch-option-title' | translate }}
              <span class="subtitle">{{
                'reference-value-sheet.create-from-standard.scratch-option-subtitle' | translate
              }}</span>
            </p>

            <button
              matListItemMeta
              type="button"
              mat-flat-button
              color="accent"
              (click)="fromScratchCreate()"
              data-test="createFromScratch"
            >
              <mat-icon>{{ (ltr$ | async) ? 'arrow_forward' : 'arrow_back' }}</mat-icon>
              {{ 'reference-value-sheet.create-from-standard.scratch-button' | translate }}
            </button>
          </mat-list-item>
        </mat-list>
      </agr-summary-card>
    </div>

    <div class="card" *ngIf="(standardRefValSheets$ | async)?.length > 0">
      <agr-summary-card
        [title]="
          'reference-value-sheet.create-from-standard.reference-value-sheet-title' | translate
        "
        [canExpand]="false"
        [actions]="[]"
      >
        <mat-list>
          <mat-list-item
            *ngFor="let refValSheet of standardRefValSheets$ | async"
            class="list-item"
          >
            <p matListItemTitle>
              {{ refValSheet.name }}
              <span class="subtitle"
                >{{ refValSheet.referenceValueSheetRows.length }}
                {{
                  ('reference-value-sheet.create.number-of-days' | translate).toLowerCase()
                }}</span
              >
            </p>
            <button
              matListItemMeta
              type="button"
              mat-flat-button
              color="accent"
              (click)="createRefValSheetFromStandard(refValSheet)"
              data-test="createFromStandard"
            >
              <mat-icon>{{ (ltr$ | async) ? 'arrow_forward' : 'arrow_back' }}</mat-icon>

              {{
                'reference-value-sheet.create-from-standard.reference-value-sheet-button'
                  | translate
              }}
              {{ refValSheet.name }}
            </button>
          </mat-list-item>
        </mat-list>
      </agr-summary-card>
    </div>
  </div>
</agr-page-toolbar>
